import { Component, OnInit, ViewChild } from '@angular/core';
import { CouponEntryComponent } from '../coupon-entry/coupon-entry.component';
import { MatDialog, MatTableDataSource, MatPaginator } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { CouponService } from 'src/app/services/http/business/coupon/coupon.service';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { AssignCouponComponent } from '../assign-coupon/assign-coupon.component';
import { CouponSearchComponent } from '../coupon-search/coupon-search.component';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';

@Component({
  selector: 'app-coupon-list',
  templateUrl: './coupon-list.component.html',
  styleUrls: ['./coupon-list.component.css']
})
export class CouponListComponent implements OnInit {

  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  errors = new Array();
  now = new Date();
  isOwner: boolean;

  pageSize: number;
  nationalCode = null;
  pageIndex: number;
  displayedColumns: string[] = [
    this.translate.get("label.code"),
    this.translate.get("label.discount"),
    this.translate.get("label.couponCategory"),
    this.translate.get("label.startDate"),
    this.translate.get("label.expirationDate"),
    this.translate.get("label.marketer"),
    this.translate.get("label.assigned"),
    this.translate.get("label.status"),
    "function"
  ];

  constructor(private dialog: MatDialog,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private couponService: CouponService) { }

  ngOnInit() {
    this.checkOwner();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      this.loadTable(res.IsOwner);
    });
  }

  getColor(e) {
    if (new Date(e.ExpirationDate) < this.now) {
      return "custom-chips default"
    }
    else {
      switch (e.CouponIsActive) {
        case true:
          return "custom-chips primary";
        case false:
          return "custom-chips accent";
      }
    }
  }

  getExpirationDate(e) {
    return new Date(e.ExpirationDate);
  }

  search() {
    this.dialog
      .open(CouponSearchComponent, {
        width: '550px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {
        this.nationalCode = res.NationalCode;
        this.dataSource = null;
        this.couponService.listOwner(res.NationalCode, res.StudentNationalCode, 1, 20).subscribe(res => {
          this.dataSource = new MatTableDataSource(res.DataList);
          this.paginator.length = res.Total;
          this.paginator.pageIndex = 0;
          this.paginator.pageSize = 20;
        }, () => {
        }
        );


      });
  }

  add() {
    this.dialog
      .open(CouponEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.couponService.listOwner(null, null, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
          this.dataSource = res.DataList;
          this.paginator.length = res.Total;
        });
      });
  }


  ative(e): void {
    let confirm: IConfirm = {
      accept: true,
      message: e.CouponIsActive
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.coupon") + " " + "'" + e.CouponCode + "'"
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.coupon") + " " + "'" + e.CouponCode + "'"
        }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var activate: any = {
        IsActive: !e.CouponIsActive,
        Id: e.Id
      };
      if (result) {
        this.couponService.activeDeactiveCouponAdmin(activate).subscribe(
          () => {
            this.paginatorEvent({
              pageIndex: this.paginator.pageIndex,
              pageSize: this.paginator.pageSize
            });
          },
          () => {
            this.errorService.transactionError();
          }
        );
      }
    });
  }

  paginatorEvent(event) {
    if (this.isOwner) {
      this.couponService
        .listOwner(this.nationalCode, null, event.pageIndex + 1, event.pageSize)
        .subscribe(res => {
          this.pageSize = event.pageSize;
          this.pageIndex = event.pageIndex + 1;
          this.dataSource = new MatTableDataSource(res.DataList);
          this.paginator.length = res.Total;
        });
    }
    else {
      this.couponService
        .listUser(null, null, null, event.pageIndex + 1, event.pageSize)
        .subscribe(res => {
          this.pageSize = event.pageSize;
          this.pageIndex = event.pageIndex + 1;
          this.dataSource = new MatTableDataSource(res.DataList);
          this.paginator.length = res.Total;
        });
    }

  }

  loadTable(isOwner: boolean) {
    this.dataSource = null;
    if (isOwner) {
      this.couponService.listOwner(null, null, 1, 20).subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 20;
      }, () => {
      }
      );
    }
    else {
      this.couponService.listUser(null, null, null, 1, 20).subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 20;
      }, () => {
      }
      );
    }
  }


  assign(e) {
    this.dialog
      .open(AssignCouponComponent, {
        data: e
      })
      .afterClosed()
      .subscribe(() => {
        console.log(this.pageSize);
        this.paginatorEvent({
          pageIndex: this.paginator.pageIndex,
          pageSize: this.paginator.pageSize
        });
      });
  }


  //unassign(e): void {
  //  let confirm: IConfirm = {
  //    accept: true,
  //    message: this.translate.get("confirm.unassign", {
  //      name: this.translate.get("label.coupon") + " " + "'" + e.CouponCodeReadOnly + "'"
  //    }),
  //alert:null,
  //    yesLabel: this.translate.get("label.yes"),
  //    noLabel: this.translate.get("label.no")
  //  };

  //  const dialogRef = this.dialog.open(ConfirmComponent, {
  //    width: "250px",
  //    data: confirm
  //  });

  //  dialogRef.afterClosed().subscribe(result => {
  //    var activate: any = {
  //      IsActive: !e.IsActive,
  //      Id: e.Id
  //    };
  //    if (result) {
  //      this.couponService.activeDeactiveCouponAdmin(activate).subscribe(
  //        res => {
  //          this.paginatorEvent({
  //            pageIndex: this.paginator.pageIndex,
  //            pageSize: this.paginator.pageSize
  //          });
  //        },
  //        err => {
  //          this.errorService.transactionError();
  //        }
  //      );
  //    }
  //  });
  //}


}
